// Chat.jsx
import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import { useLocalDB } from "../../contexts/LocalDBContext";
import Header from "../../components/Header";
import SubHeader from "../../components/SubHeader";
import "./Chat.scss";

const Chat = () => {
  const { id } = useParams();
  const { getAllStudios, getStudioById } = useLocalDB();
  const [studio, setStudio] = useState(null);
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const chatRef = useRef(null);

  const storageKey = id ? `chat_${id}` : "chat_default";

  useEffect(() => {
    const initChat = async () => {
      let targetStudio = null;
      if (id) {
        targetStudio = await getStudioById(id);
      } else {
        const studios = await getAllStudios();
        targetStudio = studios[0];
      }
      setStudio(targetStudio);

      const stored = localStorage.getItem(storageKey);
      if (stored) {
        setMessages(JSON.parse(stored));
      } else {
        const demo = [
          { sender: "studio", text: "Здравствуйте! Чем можем помочь?" },
          { sender: "user", text: "Здравствуйте! Хотел бы заказать проект интерьера." },
          { sender: "studio", text: "С удовольствием поможем! Уточните, пожалуйста, площадь." },
        ];
        localStorage.setItem(storageKey, JSON.stringify(demo));
        setMessages(demo);
      }
    };

    initChat();
  }, [id]);

  useEffect(() => {
    chatRef.current?.scrollTo(0, chatRef.current.scrollHeight);
  }, [messages]);

  const handleSend = () => {
    if (!input.trim()) return;
    const updated = [...messages, { sender: "user", text: input.trim() }];
    setMessages(updated);
    localStorage.setItem(storageKey, JSON.stringify(updated));
    setInput("");

    // Simulate response
    setTimeout(() => {
      const response = {
        sender: "studio",
        text: "Спасибо за сообщение! Мы скоро свяжемся с вами."
      };
      const full = [...updated, response];
      setMessages(full);
      localStorage.setItem(storageKey, JSON.stringify(full));
    }, 1000);
  };

  return (
    <>
      <Header />
      <SubHeader />
      <div className="chat-flex">
      <div className="card chat-window" ref={chatRef}>
        <div class="element-col"><h1>Чат с {studio ? studio.name : "студией"}</h1></div>
        <div class="element-col chat-col">
        {messages.map((msg, idx) => (
          <div
            key={idx}
            className={`chat-bubble mb-3 p-2 rounded ${msg.sender === "user" ? "user-msg" : "studio-msg"}`}
          >
            {msg.sender === "studio" && studio ? (
              <strong>{studio.name}: </strong>
            ) : null}
            {msg.text}
          </div>
        ))}
        </div>
      </div>
      <div className="input-group mt-3">
        <input
          type="text"
          className="form-control"
          placeholder="Напишите сообщение..."
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && handleSend()}
        />
        <button className="btn btn-primary" onClick={handleSend}>Отправить</button>
      </div>
      </div>
      
    </>
  );
};

export default Chat;